module.exports = __webpack_public_path__ + "img/SNDK.OQ.b049b3c9.png";